// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-image {
    width: 100%;
    background: linear-gradient(to bottom right, #f38653, #582913);
    padding: 8rem 3rem;
}

.login-image-container {
  width: auto;
  min-height: 506px;
  height: 100%;
  /* margin: 8rem 3rem; */
  border-radius: 16px;
  border: 1px solid #fff;
  background: rgba(255, 228, 215, 0.08);
  backdrop-filter: blur(13px);
}
`, "",{"version":3,"sources":["webpack://./src/pages/loginPage/web/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8DAA8D;IAC9D,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;AAC7B","sourcesContent":[".login-image {\n    width: 100%;\n    background: linear-gradient(to bottom right, #f38653, #582913);\n    padding: 8rem 3rem;\n}\n\n.login-image-container {\n  width: auto;\n  min-height: 506px;\n  height: 100%;\n  /* margin: 8rem 3rem; */\n  border-radius: 16px;\n  border: 1px solid #fff;\n  background: rgba(255, 228, 215, 0.08);\n  backdrop-filter: blur(13px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
